import { AFDataObject, AFMessageType } from ".";

export interface DevClusterRawData {
  tokenAddress: string;
  buyerCount: number;
  previousBuyerCount: number;
  startTimestamp: Date;
  timestamp: Date;
}

export interface DevClusterStateData extends DevClusterRawData {
  lastUpdated: Date;
  buyerCountChange: number;
  buyerCountChangePercentage: number;
}

export class DevCluster implements AFDataObject<DevClusterRawData, DevClusterStateData> {
  public tokenAddress: string;
  public buyerCount: number;
  public previousBuyerCount: number;
  public startTimestamp: Date;
  public timestamp: Date;
  public lastUpdated: Date;

  constructor(data: DevClusterRawData | DevClusterStateData | null, lastUpdated?: Date) {
    // 기본값 설정
    this.tokenAddress = data?.tokenAddress || '';
    this.buyerCount = data?.buyerCount || 0;
    this.previousBuyerCount = data?.previousBuyerCount || 0;
    this.startTimestamp = new Date(data?.startTimestamp || 0);
    this.timestamp =  new Date(data?.timestamp || 0);
    this.lastUpdated = new Date(lastUpdated || 0);
  }

  static create(data: DevClusterRawData | DevClusterStateData, lastUpdated?: Date): DevCluster {
    return new DevCluster(data, lastUpdated);
  }

  getMessageType(): AFMessageType {
    return AFMessageType.DEV_CLUSTER_COUNT;
  }

  toRawData(): DevClusterRawData {
    return {
      tokenAddress: this.tokenAddress,
      buyerCount: this.buyerCount,
      previousBuyerCount: this.previousBuyerCount,
      startTimestamp: this.startTimestamp,
      timestamp: this.timestamp
    };
  }

  toStateData(): DevClusterStateData {
    const buyerCountChange = this.buyerCount - this.previousBuyerCount;
    const buyerCountChangePercentage = this.previousBuyerCount > 0 
      ? (buyerCountChange / this.previousBuyerCount) * 100 
      : 0;

    return {
      ...this.toRawData(),
      lastUpdated: this.lastUpdated,
      buyerCountChange,
      buyerCountChangePercentage: Number(buyerCountChangePercentage.toFixed(2))
    };
  }

  update(data: DevClusterRawData, lastUpdated?: Date): void {
    this.tokenAddress = data.tokenAddress;
    this.buyerCount = data.buyerCount;
    this.previousBuyerCount = data.previousBuyerCount;
    this.startTimestamp = new Date(data.startTimestamp);
    this.timestamp = new Date(data.timestamp);
    this.lastUpdated = new Date(lastUpdated || Date.now());
  }

  filter(existingData: DevClusterStateData): boolean {
    return Number(this.timestamp) > Number(existingData.lastUpdated);
  }
} 